// Customizer const
export const TOGGLE_COLLAPSED_NAV = "toggle_collapse_menu";
export const DRAWER_TYPE = "drawer_type";
export const FIXED_DRAWER = "fixed_drawer";
export const COLLAPSED_DRAWER = "collapsible";
export const MINI_DRAWER = "mini_drawer";
export const THEME_COLOR = "theme_color";
export const DARK_THEME = "dark_theme";
export const WINDOW_WIDTH = "window-width";
export const SWITCH_LANGUAGE = "switch-language";
export const CHANGE_DIRECTION = "change-direction";

export const CHANGE_NAVIGATION_STYLE = "change-navigation-style";
export const HORIZONTAL_NAVIGATION = "horizontal_navigation";
export const VERTICAL_NAVIGATION = "vertical_navigation";

export const HORIZONTAL_MENU_POSITION = "horizontal_menu_position";
export const ABOVE_THE_HEADER = "above_the_header";
export const INSIDE_THE_HEADER = "inside_the_header";
export const BELOW_THE_HEADER = "below_the_header";

//Auth const
export const USER_SIGNIN = "user_signin";
export const USER_SIGNIN_SUCCESS = "user_signin_success";
export const USER_SIGNOUT = "user_signout";
export const USER_SIGNOUT_SUCCESS = "user_signout_success";
export const USER_PROFILE_FETCH = "user_profile_fetch";
export const USER_PROFILE_FETCH_SUCCESS = "user_profile_fetch_success";
export const INIT_URL = "init_url";
export const DEALER_SIGNIN = "dealer_signin";
export const DEALER_SIGNIN_SUCCESS = "dealer_signin_success";
export const DEALER_SIGNOUT = "dealer_signout";
export const DEALER_SIGNOUT_SUCCESS = "dealer_signout_success";

// User
export const USER_CREATE = "user_create";
export const USER_UPDATE = "user_update";
export const USER_DELETE = "user_delete";
export const USER_FETCH = "user_fetch";
export const USER_FETCH_SUCCESS = "user_fetch_success";
export const USER_FETCH_RESET = "user_fetch_reset";
export const USERS_FETCH = "users_fetch";
export const USERS_FETCH_SUCCESS = "users_fetch_success";
export const USERS_FETCH_RESET = "users_fetch_reset";

// Notification
export const HIDE_MESSAGE = "hide_message";
export const ON_SHOW_LOADER = "on_show_loader";
export const ON_HIDE_LOADER = "on_hide_loader";
export const SHOW_INFO_MESSAGE = "show_info_message";
export const SHOW_SUCCESS_MESSAGE = "show_success_message";
export const SHOW_WARNING_MESSAGE = "show_warning_message";
export const SHOW_ERROR_MESSAGE = "show_error_message";

// Dealer
export const DEALER_CREATE = "dealer_create";
export const DEALER_UPDATE = "dealer_update";
export const DEALER_DELETE = "dealer_delete";
export const DEALER_FETCH = "dealer_fetch";
export const DEALER_FETCH_SUCCESS = "dealer_fetch_success";
export const DEALER_FETCH_RESET = "dealer_fetch_reset";
export const DEALERS_FETCH = "dealers_fetch";
export const DEALERS_FETCH_SUCCESS = "dealers_fetch_success";
export const DEALERS_FETCH_RESET = "dealers_fetch_reset";
export const DEALER_PROVINCES_FETCH = "dealer_provinces_fetch";
export const DEALER_PROVINCES_FETCH_SUCCESS = "dealer_provinces_fetch_success";
export const DEALER_PROVINCES_FETCH_EN_SUCCESS = "dealer_provinces_fetch_en_success";
export const DEALER_PROVINCES_FETCH_RESET = "dealer_provinces_fetch_reset";
export const DEALER_PROVINCES_FETCH_EN_RESET = "dealer_provinces_fetch_en_reset";

// Ticket
export const TICKET_CREATE = "ticket_create";
export const TICKET_UPDATE = "ticket_update";
export const TICKET_VERIFIED_UPDATE = "ticket_verified_update";
export const TICKET_DELETE = "ticket_delete";
export const TICKET_CANCEL = "ticket_cancel";
export const TICKET_FETCH = "ticket_fetch";
export const TICKET_FETCH_SUCCESS = "ticket_fetch_success";
export const TICKET_FETCH_RESET = "ticket_fetch_reset";
export const TICKETS_FETCH = "tickets_fetch";
export const TICKETS_FETCH_SUCCESS = "tickets_fetch_success";
export const TICKETS_FETCH_RESET = "tickets_fetch_reset";
export const TICKETS_SERVICE_FETCH = "tickets_service_fetch";
export const TICKETS_SERVICE_FETCH_SUCCESS = "tickets_service_fetch_success";
export const TICKETS_SERVICE_FETCH_RESET = "tickets_service_fetch_reset";
export const TICKETS_SHOWROOM_FETCH = "tickets_showroom_fetch";
export const TICKETS_SHOWROOM_FETCH_SUCCESS = "tickets_showroom_fetch_success";
export const TICKETS_SHOWROOM_FETCH_RESET = "tickets_showroom_fetch_reset";
export const TICKETS_HOTSHEET_SERVICE_FETCH = "tickets_hotsheet_service_fetch";
export const TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS = "tickets_hotsheet_service_fetch_success";
export const TICKETS_HOTSHEET_SERVICE_FETCH_RESET = "tickets_hotsheet_service_fetch_reset";
export const TICKETS_HOTSHEET_SHOWROOM_FETCH = "tickets_hotsheet_showroom_fetch";
export const TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS = "tickets_hotsheet_showroom_fetch_success";
export const TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET = "tickets_hotsheet_showroom_fetch_reset";
export const TICKETS_CALLCENTER_SERVICE_FETCH = "tickets_callcenter_service_fetch";
export const TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS = "tickets_callcenter_service_fetch_success";
export const TICKETS_CALLCENTER_SERVICE_FETCH_RESET = "tickets_callcenter_service_fetch_reset";
export const TICKETS_CALLCENTER_SHOWROOM_FETCH = "tickets_callcenter_showroom_fetch";
export const TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS = "tickets_callcenter_showroom_fetch_success";
export const TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET = "tickets_callcenter_showroom_fetch_reset";
export const TICKETS_SERVICE_REPORT_STATUS_FETCH = "tickets_service_report_status_fetch";
export const TICKETS_SERVICE_REPORT_STATUS_FETCH_SUCCESS = "tickets_service_report_status_fetch_success";
export const TICKETS_SERVICE_REPORT_STATUS_FETCH_RESET = "tickets_service_report_status_fetch_reset";
export const TICKETS_SHOWROOM_REPORT_STATUS_FETCH = "tickets_showroom_report_status_fetch";
export const TICKETS_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS = "tickets_showroom_report_status_fetch_success";
export const TICKETS_SHOWROOM_REPORT_STATUS_FETCH_RESET = "tickets_showroom_report_status_fetch_reset";
export const TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH = "tickets_hotsheet_service_report_status_fetch";
export const TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_SUCCESS = "tickets_hotsheet_service_report_status_fetch_success";
export const TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_RESET = "tickets_hotsheet_service_report_status_fetch_reset";
export const TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH = "tickets_hotsheet_showroom_report_status_fetch";
export const TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS = "tickets_hotsheet_showroom_report_status_fetch_success";
export const TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_RESET = "tickets_hotsheet_showroom_report_status_fetch_reset";
export const TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH = "tickets_callcenter_service_report_status_fetch";
export const TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_SUCCESS = "tickets_callcenter_service_report_status_fetch_success";
export const TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_RESET = "tickets_callcenter_service_report_status_fetch_reset";
export const TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH = "tickets_callcenter_showroom_report_status_fetch";
export const TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS = "tickets_callcenter_showroom_report_status_fetch_success";
export const TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_RESET = "tickets_callcenter_showroom_report_status_fetch_reset";
export const TICKETS_EXPORT_EXCEL = "tickets_export_excel";
export const TICKET_LOGS_UPDATE = "ticket_logs_update";

// REPORT
export const REPORT_COMPLAINT_CAR_MODEL_FETCH = "report_complaint_car_model_fetch";
export const REPORT_COMPLAINT_CAR_MODEL_FETCH_SUCCESS = "report_complaint_car_model_fetch_success";
export const REPORT_COMPLAINT_CAR_MODEL_FETCH_RESET = "report_complaint_car_model_fetch_reset";
export const REPORT_COMPLAINT_CATEGORIES_FETCH = "report_complaint_categories_fetch";
export const REPORT_COMPLAINT_CATEGORIES_FETCH_SUCCESS = "report_complaint_categories_fetch_success";
export const REPORT_COMPLAINT_CATEGORIES_FETCH_RESET = "report_complaint_categories_fetch_reset";
export const REPORT_SURVEY_FETCH = "report_survey_fetch";
export const REPORT_SURVEY_FETCH_SUCCESS = "report_survey_fetch_success";
export const REPORT_SURVEY_FETCH_RESET = "report_survey_fetch_reset";
export const REPORT_TICKET_FETCH = "report_ticket_fetch";
export const REPORT_TICKET_FETCH_SUCCESS = "report_ticket_fetch_success";
export const REPORT_TICKET_FETCH_RESET = "report_ticket_fetch_reset";
export const REPORT_TICKET_3MONTHS_FETCH = "report_ticket_3months_fetch";
export const REPORT_TICKET_3MONTHS_FETCH_SUCCESS = "report_ticket_3months_fetch_success";
export const REPORT_TICKET_3MONTHS_FETCH_RESET = "report_ticket_3months_fetch_reset";
export const REPORT_TICKET_6MONTHS_FETCH = "report_ticket_6months_fetch";
export const REPORT_TICKET_6MONTHS_FETCH_SUCCESS = "report_ticket_6months_fetch_success";
export const REPORT_TICKET_6MONTHS_FETCH_RESET = "report_ticket_6months_fetch_reset";
export const REPORT_TICKET_YTD_FETCH = "report_ticket_ytd_fetch";
export const REPORT_TICKET_YTD_FETCH_SUCCESS = "report_ticket_ytd_fetch_success";
export const REPORT_TICKET_YTD_FETCH_RESET = "report_ticket_ytd_fetch_reset";
export const REPORT_TICKET_SHOWROOM_STATUSES_FETCH = "report_ticket_showroom_statuses_fetch";
export const REPORT_TICKET_SHOWROOM_STATUSES_FETCH_SUCCESS = "report_ticket_showroom_statuses_fetch_success";
export const REPORT_TICKET_SHOWROOM_STATUSES_FETCH_RESET = "report_ticket_showroom_statuses_fetch_reset";
export const REPORT_TICKET_SERVICE_STATUSES_FETCH = "report_ticket_service_statuses_fetch";
export const REPORT_TICKET_SERVICE_STATUSES_FETCH_SUCCESS = "report_ticket_service_statuses_fetch_success";
export const REPORT_TICKET_SERVICE_STATUSES_FETCH_RESET = "report_ticket_service_statuses_fetch_reset";
export const REPORT_TICKETS_SHOWROOM_FETCH = "report_tickets_showroom_fetch";
export const REPORT_TICKETS_SHOWROOM_FETCH_SUCCESS = "report_tickets_showroom_fetch_success";
export const REPORT_TICKETS_SHOWROOM_FETCH_RESET = "report_tickets_showroom_fetch_reset";
export const REPORT_TICKETS_SERVICE_FETCH = "report_tickets_service_fetch";
export const REPORT_TICKETS_SERVICE_FETCH_SUCCESS = "report_tickets_service_fetch_success";
export const REPORT_TICKETS_SERVICE_FETCH_RESET = "report_tickets_service_fetch_reset";
export const REPORT_TICKETS_SHOWROOM_FORM_UPDATE = "report_tickets_showroom_form_update";
export const REPORT_TICKETS_SERVICE_FORM_UPDATE = "report_tickets_service_form_update"
export const REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH = "report_ticket_hotsheet_showroom_statuses_fetch";
export const REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_SUCCESS = "report_ticket_hotsheet_showroom_statuses_fetch_success";
export const REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH_RESET = "report_ticket_hotsheet_showroom_statuses_fetch_reset";
export const REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH = "report_ticket_hotsheet_service_statuses_fetch";
export const REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_SUCCESS = "report_ticket_hotsheet_service_statuses_fetch_success";
export const REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH_RESET = "report_ticket_hotsheet_service_statuses_fetch_reset";
export const REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH = "report_tickets_hotsheet_showroom_fetch";
export const REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS = "report_tickets_hotsheet_showroom_fetch_success";
export const REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET = "report_tickets_hotsheet_showroom_fetch_reset";
export const REPORT_TICKETS_HOTSHEET_SERVICE_FETCH = "report_tickets_hotsheet_service_fetch";
export const REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS = "report_tickets_hotsheet_service_fetch_success";
export const REPORT_TICKETS_HOTSHEET_SERVICE_FETCH_RESET = "report_tickets_hotsheet_service_fetch_reset";
export const REPORT_TICKETS_HOTSHEET_SHOWROOM_FORM_UPDATE = "report_tickets_hotsheet_showroom_form_update";
export const REPORT_TICKETS_HOTSHEET_SERVICE_FORM_UPDATE = "report_tickets_hotsheet_service_form_update";
export const REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH = "report_ticket_callcenter_showroom_statuses_fetch";
export const REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_SUCCESS = "report_ticket_callcenter_showroom_statuses_fetch_success";
export const REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH_RESET = "report_ticket_callcenter_showroom_statuses_fetch_reset";
export const REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH = "report_ticket_callcenter_service_statuses_fetch";
export const REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_SUCCESS = "report_ticket_callcenter_service_statuses_fetch_success";
export const REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH_RESET = "report_ticket_callcenter_service_statuses_fetch_reset";
export const REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH = "report_tickets_callcenter_showroom_fetch";
export const REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS = "report_tickets_callcenter_showroom_fetch_success";
export const REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET = "report_tickets_callcenter_showroom_fetch_reset";
export const REPORT_TICKETS_CALLCENTER_SERVICE_FETCH = "report_tickets_callcenter_service_fetch";
export const REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS = "report_tickets_callcenter_service_fetch_success";
export const REPORT_TICKETS_CALLCENTER_SERVICE_FETCH_RESET = "report_tickets_callcenter_service_fetch_reset";
export const REPORT_TICKETS_CALLCENTER_SHOWROOM_FORM_UPDATE = "report_tickets_callcenter_showroom_form_update";
export const REPORT_TICKETS_CALLCENTER_SERVICE_FORM_UPDATE = "report_tickets_callcenter_service_form_update";
export const REPORT_TICKET_KPI_FETCH = "report_ticket_kpi_fetch";
export const REPORT_TICKET_KPI_FETCH_RESET = "report_ticket_kpi_fetch_reset";
export const REPORT_TICKET_KPI_FETCH_SUCCESS = "report_ticket_kpi_fetch_success";
export const REPORT_TICKET_KPI_3MONTHS_FETCH = "report_ticket_kpi_3months_fetch";
export const REPORT_TICKET_KPI_3MONTHS_FETCH_RESET = "report_ticket_kpi_3months_fetch_reset";
export const REPORT_TICKET_KPI_3MONTHS_FETCH_SUCCESS = "report_ticket_kpi_3months_fetch_success";
export const REPORT_TICKET_KPI_6MONTHS_FETCH = "report_ticket_kpi_6months_fetch";
export const REPORT_TICKET_KPI_6MONTHS_FETCH_RESET = "report_ticket_kpi_6months_fetch_reset";
export const REPORT_TICKET_KPI_6MONTHS_FETCH_SUCCESS = "report_ticket_kpi_6months_fetch_success";
export const REPORT_TICKET_KPI_YTD_FETCH = "report_ticket_kpi_ytd_fetch";
export const REPORT_TICKET_KPI_YTD_FETCH_RESET = "report_ticket_kpi_ytd_fetch_reset";
export const REPORT_TICKET_KPI_YTD_FETCH_SUCCESS = "report_ticket_kpi_ytd_fetch_success";
export const REPORT_TICKET_KPI_SURVEY_FETCH = "report_ticket_kpi_survey_fetch";
export const REPORT_TICKET_KPI_SURVEY_FETCH_RESET = "report_ticket_kpi_survey_fetch_reset";
export const REPORT_TICKET_KPI_SURVEY_FETCH_SUCCESS = "report_ticket_kpi_survey_fetch_success";
export const REPORT_CASE_CLOSED_EXPORT_EXCEL = "report_case_closed_export_excel";
export const REPORT_CASE_CLOSED_V1_EXPORT_EXCEL = "report_case_closed_v1_export_excel";
export const REPORT_RESPONSE_RATE_SHOWROOM_FETCH = "report_response_rate_showroom_fetch";
export const REPORT_RESPONSE_RATE_SHOWROOM_FETCH_RESET = "report_response_rate_fetch_showroom_reset";
export const REPORT_RESPONSE_RATE_SHOWROOM_FETCH_SUCCESS = "report_response_rate_fetch_showroom_success";
export const REPORT_RESPONSE_RATE_SERVICE_FETCH = "report_response_rate_service_fetch";
export const REPORT_RESPONSE_RATE_SERVICE_FETCH_RESET = "report_response_rate_fetch_service_reset";
export const REPORT_RESPONSE_RATE_SERVICE_FETCH_SUCCESS = "report_response_rate_fetch_service_success";
export const REPORT_RESPONSE_RATE_EXPORT_EXCEL = "report_response_rate_export_excel";
export const REPORT_NOTIFY_SHOWROOM_FETCH = "report_notify_showroom_fetch";
export const REPORT_NOTIFY_SHOWROOM_FETCH_RESET = "report_notify_showroom_fetch_reset";
export const REPORT_NOTIFY_SHOWROOM_FETCH_SUCCESS = "report_notify_showroom_fetch_success";
export const REPORT_NOTIFY_SERVICE_FETCH = "report_notify_service_fetch";
export const REPORT_NOTIFY_SERVICE_FETCH_RESET = "report_notify_service_fetch_reset";
export const REPORT_NOTIFY_SERVICE_FETCH_SUCCESS = "report_notify_service_fetch_success";
export const REPORT_NOTIFY_EXPORT_EXCEL = "report_notify_export_excel";
export const REPORT_PDCA_EXPORT_EXCEL = 'report_pdca_export_excel';
export const REPORT_TICKET_KPI_EXPORT_EXCEL = "report_ticket_kpi_export_excel";
export const REPORT_QVOC_KPI_EXPORT_EXCEL = "report_qvoc_kpi_export_excel";
export const REPORT_QVOC_KPI_FETCH = "report_qvoc_kpi_fetch";
export const REPORT_QVOC_KPI_FETCH_RESET = "report_qvoc_kpi_fetch_reset";
export const REPORT_QVOC_KPI_FETCH_SUCCESS = "report_qvoc_kpi_fetch_success";
export const REPORT_TICKET_KPI_ALL_FETCH = "report_ticket_kpi_all_fetch";
export const REPORT_TICKET_KPI_ALL_FETCH_RESET = "report_ticket_kpi_all_fetch_reset";
export const REPORT_TICKET_KPI_ALL_FETCH_SUCCESS = "report_ticket_kpi_all_fetch_success";

// UPLOAD
export const UPLOADS_FETCH = "uploads_fetch";
export const UPLOADS_FETCH_SUCCESS = "uploads_fetch_success";
export const UPLOADS_FETCH_RESET = "uploads_fetch_reset"

// SUB CATEGORY
export const SUB_CATEGORIES_FETCH = "sub_categories_fetch";
export const SUB_CATEGORIES_FETCH_SUCCESS = "sub_categories_fetch_success";
export const SUB_CATEGORIES_FETCH_RESET = "sub_categories_fetch_resett"

// PROBLEM LIST
export const PROBLEM_LISTS_FETCH = "problem_lists_fetch";
export const PROBLEM_LISTS_FETCH_SUCCESS = "problem_lists_fetch_success";
export const PROBLEM_LISTS_FETCH_RESET = "problem_lists_fetch_reset";